import { IAPIRoutes } from "../../../../config";
import {
  MOCK_HPI_TEMPLATES,
  USE_MOCK_DATA,
} from "./hpiTemplateRepository.mock";

export type IHPITemplateRepository = {
  createHPITemplateAPI: ICreateHPITemplateAPI;
  getHPITemplatesAPI: IGetHPITemplatesAPI;
  getSingleHPITemplateAPI: IGetSingleHPITemplateAPI;
  updateHPITemplateAPI: IUpdateHPITemplateAPI;
  deleteHPITemplateAPI: IDeleteHPITemplateAPI;
};

export const HPITemplateRepositoryFactory = ({
  APIProvider,
  AuthService,
  APIRoutes,
}: {
  APIProvider: IAPIProvider;
  AuthService: IAuthService;
  APIRoutes: IAPIRoutes;
}): IHPITemplateRepository => {
  const { GET, POST, PUT, DELETE } = APIProvider;
  const { getAuthenticationToken } = AuthService;

  const createHPITemplateAPI: ICreateHPITemplateAPI = async (payload) =>
    POST(APIRoutes.apiCreateHPITemplate, payload, {
      Authorization: `Bearer ${await getAuthenticationToken()}`,
      "Content-Type": "application/json",
    });

  const getHPITemplatesAPI: IGetHPITemplatesAPI = async (payload) => {
    // Return mock data if enabled (for development before backend is ready)
    if (USE_MOCK_DATA) {
      // Simulate API delay
      await new Promise((resolve) => setTimeout(resolve, 500));
      return MOCK_HPI_TEMPLATES;
    }

    return GET(
      APIRoutes.apiGetHPITemplates,
      { clinic_id: payload.clinic_id },
      {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
      }
    );
  };

  const getSingleHPITemplateAPI: IGetSingleHPITemplateAPI = async (payload) => {
    // Return mock data if enabled (for development before backend is ready)
    if (USE_MOCK_DATA) {
      // Simulate API delay
      await new Promise((resolve) => setTimeout(resolve, 300));
      const template = MOCK_HPI_TEMPLATES.templates.find(
        (t) => t.id === payload.template_id
      );
      if (template) {
        return template;
      }
      throw new Error(`Template with id ${payload.template_id} not found`);
    }

    return GET(
      APIRoutes.apiGetSingleHPITemplate.replace(
        "{template_id}",
        payload.template_id.toString()
      ),
      {},
      {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
      }
    );
  };

  const updateHPITemplateAPI: IUpdateHPITemplateAPI = async (payload) =>
    PUT(APIRoutes.apiUpdateHPITemplate, payload, {
      Authorization: `Bearer ${await getAuthenticationToken()}`,
      "Content-Type": "application/json",
    });

  const deleteHPITemplateAPI: IDeleteHPITemplateAPI = async (payload) =>
    DELETE(
      APIRoutes.apiDeleteHPITemplate.replace(
        "{template_id}",
        payload.template_id.toString()
      ),
      {},
      {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
      }
    );

  return {
    createHPITemplateAPI,
    getHPITemplatesAPI,
    getSingleHPITemplateAPI,
    updateHPITemplateAPI,
    deleteHPITemplateAPI,
  };
};
